import { isFilterValueActive } from "@/utils/tableFiltersStorage";

/** Keep only filters that affect the server query — empty custom-field slots do not change the key. */
export function activeFiltersForQueryKey(filters: Record<string, any> | undefined | null): Record<string, any> | undefined {
  if (!filters) return undefined;
  const active: Record<string, any> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (isFilterValueActive(value)) active[key] = value;
  }
  return Object.keys(active).length ? active : undefined;
}
